import React, { useState } from 'react';
import { useProductSearch } from './useDepositData';

/**
 * Modal for assigning a system product as the "deposit product" of a kaucja.
 * Props:
 *   depositToAssign - the deposit being configured
 *   onSelect(product) - called when user picks a product
 *   onClose()        - close the modal
 */
const AssignDepositProductModal = ({ depositToAssign, onSelect, onClose }) => {
  const [assignProductSearch, setAssignProductSearch] = useState('');

  const { results: assignProductResults, searching: assignProductLoading } =
    useProductSearch(assignProductSearch);

  const handleClose = () => {
    setAssignProductSearch('');
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 1001
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '8px',
        width: '90%', maxWidth: '600px', maxHeight: '80vh',
        overflow: 'hidden', display: 'flex', flexDirection: 'column'
      }}>
        {/* Header */}
        <div style={{
          padding: '15px 20px', backgroundColor: 'var(--warning)',
          borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h4 style={{ margin: 0 }}>
            Przypisz produkt do kaucji: {depositToAssign.nazwa}
          </h4>
          <button onClick={handleClose} style={{ background: 'none',  fontSize: '20px', cursor: 'pointer' }}>
            &#x2715;
          </button>
        </div>

        {/* Search */}
        <div style={{ padding: '15px 20px' }}>
          <p style={{ margin: '0 0 10px 0', color: 'var(--text-secondary)', fontSize: '13px' }}>
            Wyszukaj i wybierz produkt ktory bedzie dodawany do koszyka jako kaucja
          </p>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Wpisz nazwe produktu lub kod (min. 2 znaki)..."
              value={assignProductSearch}
              onChange={(e) => setAssignProductSearch(e.target.value)}
              autoFocus
              style={{ width: '100%', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
            />
            {assignProductLoading && (
              <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }}>
                Szukam...
              </span>
            )}
          </div>

          {assignProductResults.length > 0 && (
            <div style={{
              marginTop: '10px', maxHeight: '300px', overflowY: 'auto',
              border: '1px solid var(--border)', borderRadius: '4px', backgroundColor: 'var(--card-bg)'
            }}>
              {assignProductResults.map(product => (
                <div
                  key={product.id}
                  onClick={() => onSelect(product)}
                  style={{ padding: '10px 12px', borderBottom: '1px solid var(--border)', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'var(--bg)'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'var(--card-bg)'}
                >
                  <div>
                    <div style={{ fontWeight: '500' }}>{product.nazwa || product.name}</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                      Kod: {product.kod_produktu || product.barcode || '-'} |
                      Cena: {(product.cena_sprzedazy_brutto || product.price || 0).toFixed(2)} zl
                    </div>
                  </div>
                  <span style={{ color: 'var(--success)', fontWeight: '600' }}>Wybierz &rarr;</span>
                </div>
              ))}
            </div>
          )}

          {assignProductResults.length === 0 && assignProductSearch.length >= 2 && !assignProductLoading && (
            <div style={{ marginTop: '10px', color: 'var(--text-muted)', fontSize: '12px' }}>
              Brak wynikow dla "{assignProductSearch}"
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: '15px 20px', backgroundColor: 'var(--bg)', borderTop: '1px solid var(--border)', textAlign: 'right' }}>
          <button
            onClick={handleClose}
            style={{ padding: '8px 20px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , borderRadius: '4px', cursor: 'pointer' }}
          >
            Anuluj
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignDepositProductModal;
